module.exports = __webpack_public_path__ + "img/portfolio2.49c2f981.jpg";